export type Variant = 'tag' | 'badge';

export const isBadgeVariant = (variant: Variant) => variant === 'badge';
